import styled from 'styled-components';
import { colors, spacing } from '@chegg-ui/theme';
import { StyledDropdown as CheggUiDropdown } from '../../../../components/Shared';
export var ArticlePublishedByDatabaseDropdown = styled(CheggUiDropdown).withConfig({
  componentId: "sc-1mmvu4u-0"
})(["ul li:nth-child(2),ul li:nth-child(9){display:flex;justify-content:center;padding:", " 1rem;color:", ";font-style:italic;pointer-events:none;}"], spacing.px4, colors.grey500);